module.exports = __webpack_public_path__ + "img/enterprise-main13.0edbe4fe.jpg";